import React from 'react'
import AddProductContainer from '../../../../Components/Apps/ECommerce/AddProduct'

export default function AddProduct() {
  return (
    <div className='page-body'>
        <AddProductContainer/>
    </div>
  )
}
